// What the Talk screen shows of a turn while it runs: the recogniser's
// settled words accumulate, the interim follows what is still being
// said on top of them, and the answer's pieces join in order. Pure,
// so the growing of the lines is testable without a socket.
import type { Reply, Transcript } from "@/gen/psypen/v1/session_pb";

export interface TurnText {
  // The recogniser's settled words, whole.
  heard: string;
  // What is being said right now, still moving.
  interim: string;
  // The answer's text so far, in order.
  answer: string;
}

export function emptyText(): TurnText {
  return { heard: "", interim: "", answer: "" };
}

export function applyTranscript(cur: TurnText, t: Transcript): TurnText {
  return { ...cur, heard: cur.heard + t.final, interim: t.interim };
}

export function applyReply(cur: TurnText, r: Reply): TurnText {
  return { ...cur, answer: cur.answer + r.text };
}

// The one line under the orb of the screen: what is being said, or the
// answer as it comes.
export function shownLine(cur: TurnText): string {
  return cur.answer || cur.heard + cur.interim;
}
